import React, { useEffect, useState, useRef } from "react";
import VacanciesItemHeader from "../../Components/VacanciesItem/VacanciesItemHeader/VacanciesItemHeader";
import Menu from "../../Components/General/Menu/Menu";
import Footer from "../../Components/General/Footer/Footer";
import VacanciesItemCard from "../../Components/VacanciesItem/VacanciesItemCard/VacanciesItemCard";
import VacanciesItemText from '../../Components/VacanciesItem/VacanciesItemText/VacanciesItemText'
import VacanciesItemForm from "../../Components/VacanciesItem/VacanciesItemForm/VacanciesItemForm";
import { useParams } from "react-router-dom";
import { vacanciesItem } from "./VacanciesItemLogic/VacanciesItemApi";
// ... other imports

const VacanciesItemModule = () => {
  const param = useParams();
  const [vacancieItem, setVacanciesItem] = useState();

  // Create a ref for the form
  const formRef = useRef(null);

  const getVacanciesItem = () => {
    vacanciesItem(param.id)
      .then(res => {
        setVacanciesItem(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    getVacanciesItem();
  }, []);

  // Scroll handler passed to header
  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <Menu />
      <VacanciesItemHeader
        title={vacancieItem?.title}
        img={vacancieItem?.image}
        onClickRespond={scrollToForm}  // pass handler here
      />
      <VacanciesItemCard requirements={vacancieItem?.requirements} />
      <VacanciesItemText content={vacancieItem?.content} />
      {/* Attach the ref to VacanciesItemForm */}
      <div ref={formRef}>
        <VacanciesItemForm vacancyTitle={vacancieItem?.title} />
      </div>
      <Footer />
    </div>
  );
};

export default VacanciesItemModule;
